const styles = theme => {
  return {
    root: { width: '700px', backgroundColor: '#FAFAFA' },
    content: {
      backgroundColor: '#FAFAFA',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'visible',
      [theme.breakpoints.down(theme.breakpoints.values.md - 100)]: {
        flexDirection: 'column'
      }
    },
    row: { display: 'flex', width: '100%' },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      borderTop: '1px solid #EBEDF2',
      padding: '20px 0',
      marginTop: '20px',
      '& button': {
        marginRight: '10px'
      }
    },
    dialogContent: {
      width: '700px',
      height: '560px',
      flexDirection: 'column',
      [theme.breakpoints.down(theme.breakpoints.values.md - 100)]: {
        width: '100%'
      }
    },
    userDialogContent: { height: 'fit-content' }
  };
};

export default styles;
